import React, {Component} from 'react';
import {Row, Col, ProgressBar, ButtonToolbar} from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import {TopButtonAction, TopButtonPointAction, TopButtonPointRemove} from "../../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../../utilities/TabUtilities";
import ReactTooltip from 'react-tooltip'
import LSService from "../../../../../../utilities/localStorageService/LSService";
import {Link} from "react-router-dom";
import DateAndTimeFormat from "../../../../../../utilities/DateAndTimeFormat";
import acc from 'accounting'
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import moment from "moment";
import ObsadaListaContainer from "../ObsadaListaContainer";
import ObsadaListaModal from "./ObsadaListaModal";
import PromocjeService from "../../../../biletyConfig/promocje/PromocjeService";

var tinycolor = require("tinycolor2");

export default class ObsadaListaTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pokazModal: false,
            setLoader: false,
            obsadaModal: null,
            promocjeDlaKursu: []
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)

        this.renderKierowca = this.renderKierowca.bind(this)
        this.renderPojazd = this.renderPojazd.bind(this)
        this.renderStatus = this.renderStatus.bind(this)
        this.renderKurs = this.renderKurs.bind(this)
        this.renderMiejsca = this.renderMiejsca.bind(this)
        this.onClickWyszukajBiletyNaKurs = this.onClickWyszukajBiletyNaKurs.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        if (row.czy_bis) {
            return (
                <div>
                    <ButtonToolbar>
                        <TopButtonPointAction onClick={() => {
                            if (Boolean(row.start_kursu)) {
                                alert('Uwaga! Kurs został już rozpoczęty, proszę uważnie edytować dane')
                            }
                            this.props.handleEdytujZasoby(row)
                        }} titleContent={'Edytuj zasoby'}
                                              buttonColor={'default'}
                                              buttonIcon={'fa fa-edit'}
                                              className={'btn-innertext-color-blue'}
                                              disabled={row.zablokowane === 2}
                        />
                        {
                            Boolean(row.czy_odw_obsada) ?
                                <TopButtonAction
                                    onClick={() => {
                                        this.props.handleOdwolajPrzywrocBis(row, false)
                                    }}
                                    btnColor={"default"}
                                    btnSize={'xs'}
                                    iconType={"fa fa-reply"}
                                    text={"Przywróć bis"}
                                    elementStyle={{color: "mediumseagreen", fontWeight: "normal"}}
                                    disabled={row.zablokowane === 2}

                                />
                                :
                                <TopButtonAction
                                    onClick={() => {
                                        this.props.handleOdwolajPrzywrocBis(row, true)
                                    }}
                                    btnColor={"default"}
                                    btnSize={'xs'}
                                    iconType={"fa fa-times"}
                                    text={"Odwołaj bis"}
                                    elementStyle={{color: "chocolate", fontWeight: "normal"}}
                                    disabled={row.zablokowane === 2}

                                />
                        }

                    </ButtonToolbar>
                </div>
            )
        } else {

            return (
                <div>
                    <ButtonToolbar>
                        <TopButtonPointAction onClick={() => {
                            if (Boolean(row.start_kursu)) {
                                alert('Uwaga! Kurs został już rozpoczęty, proszę uważnie duplikować dane')
                            }
                            this.props.duplikuj(row)
                        }}
                                              titleContent={'Duplikuj wpis i zmień zasoby'}
                                              buttonIcon={'fa fa-user-plus'}
                                              buttonColor={'default'}
                                              disabled={row.zablokowane === 2}
                        />
                        <TopButtonPointAction onClick={() => {
                            if (Boolean(row.start_kursu)) {
                                alert('Uwaga! Kurs został już rozpoczęty, proszę uważnie edytować dane')
                            }
                            this.props.handleEdytujZasoby(row)
                        }} titleContent={'Edytuj zasoby'}
                                              buttonColor={'default'}
                                              buttonIcon={'fa fa-edit'}
                                              className={'btn-innertext-color-blue'}
                                              disabled={row.zablokowane === 2}
                        />
                        {
                            row.zablokowane === 2 ?
                                <TopButtonPointAction onClick={() => {
                                    this.props.handleZmienStatus(row, false)
                                }} titleContent={'Przywróć kurs'}
                                                      buttonColor={'default'}
                                                      buttonIcon={'fa fa-history'}
                                                      className={'btn-innertext-color-green'}
                                                      disabled={false}

                                />
                                :
                                <TopButtonPointAction onClick={() => {
                                    if (Boolean(row.start_kursu)) {
                                        if (window.confirm('Uwaga! Kurs został już rozpoczęty. Czy na pewno chcesz odwolac kurs?')) {
                                            this.props.handleOdwolaj(row)
                                        }
                                    }
                                    else
                                        this.props.handleOdwolaj(row)
                                }} titleContent={'Odwołaj kurs'}
                                                      buttonColor={'default'}
                                                      buttonIcon={'fa fa-repeat'}
                                                      className={'btn-innertext-color-red'}
                                                      disabled={false}

                                />
                        }

                    </ButtonToolbar>
                </div>
            )
        }
    }

    formatGodzina(cell, row) {
        return (<span style={(row.zablokowane === 2 || row.czy_odw_obsada) ? {color: 'grey'} : {}}>{DateAndTimeFormat.formatHHMM(cell)}</span>)
    }

    renderEkipa(cell, row) {
        if (Boolean(row.kolor)) {

            let color = 'grey';

            if ((tinycolor(row.kolor)).isDark()) {
                color = '#ffffff'
            }
            if ((tinycolor(row.kolor)).isLight()) {
                color = '#000000'
            }

            return (
                <div>
                <span className={'label label-ebus-default'}
                      title={row.kolor}
                      style={(row.kolor.length > 1) ? {background: row.kolor, color: color} : {background: '#f5f5f5', color: '#333333'}}>
            {row.kod_ek}
            </span>
                    <div style={(row.zablokowane === 2 || row.czy_odw_obsada) ? {
                        color: 'grey',
                        fontSize: '14px',
                        marginTop: '5px'
                    } : {fontSize: '14px', marginTop: '5px'}}>
                        {row.trasa}
                    </div>
                </div>)
        } else return (<div>
            <div style={{fontSize: "10px", paddingBottom: "5px", color: "#bbb"}}>[brak ekipy]</div>
            <div>{row.trasa}</div>
        </div>)
    }

    onClickWyszukajBiletyNaKurs(obj) {
        let params = {
            idTr: obj.id_tr,
            godz: obj.godz_1p,
            data: obj.data,
            idKu: obj.id_ku,
        }
        LSService.ustawWyszukiwanieBiletowZObsad(params);
    }

    onClickWyszukajLokalizacjeKursu(obj) {
        LSService.ustawIdKursuDoWyszukaniaLokalizacji(obj.id_ku)
    }

    onClickWyswietlInformacjeOSprzedazyIPromocjach(obj) {
        this.setState({pokazModal: true, obsadaModal: obj, setLoader: true})
        PromocjeService.getPromocjeDlaKursu(obj.id_ku).then(function (response) {
            if (response) {
                if (response.status < 300)
                    this.setState({setLoader: false, promocjeDlaKursu: response.data})
            }
            this.setState({setLoader: false})
        }.bind(this))
    }

    renderKierowca(cell, row) {

        if ((row.id_ki_oryg !== row.id_ki) && Boolean(row.id_ki_oryg)) {
            // gdy była zmiana kierowcy
            return (<div>
                <div data-tip='' data-for={'obsada_row' + row.id_ob} data-place="bottom" className='tooltip_here' style={{cursor: 'pointer'}}>
                    <div style={(row.zablokowane === 2 || row.czy_odw_obsada) ? {color: 'grey'} : {}}>
                        <a style={(row.powod_zam === 'KIEROWCA') ? {color: 'red'} : {color: 'dodgerblue'}}>
                            {row.imie_naz} <span style={{fontSize: "10px", background: "#dedede"}}
                                                 className={"label label-ebus-default"}>ID: {row.id_ki}</span>
                        </a>
                    </div>
                    <div style={{color: 'grey', fontSize: '12px', fontStyle: 'italic'}}>zamiana za: {row.imie_naz_kier_oryg}</div>
                    <div style={{
                        color: 'grey',
                        fontSize: '12px',
                        fontStyle: 'italic'
                    }}>powód: {Boolean(row.uwagi) ? row.powod_zam + ' ' + row.uwagi : row.powod_zam}</div>
                    {
                        Boolean(row.nr_tel_ebus) ?
                            <div title={'Telefon eBus do kierowcy'} style={{fontSize: '12px', marginTop: '3px'}}><span
                                className={'label label-ebus-default'} style={{fontSize: 'inherit'}}>
                            <i className={'fa fa-phone'}></i> {row.nr_tel_ebus}
                        </span>
                            </div>
                            :
                            ''
                    }
                </div>
                <ReactTooltip id={'obsada_row' + row.id_ob}>
                    <div>
                        <p><label>Obecny kierowca: </label>{row.imie_naz} (ID: {row.id_ki})</p>
                        <p><label>Oryginalny kierowca: </label>{row.imie_naz_kier_oryg} (ID: {row.id_ki_oryg})</p>
                        <p><label>Powód zamiany:</label> {Boolean(row.uwagi) ? row.powod_zam + ' ' + row.uwagi : row.powod_zam}</p>
                        {
                            <p><label>Zmieniony przez:</label> {(row.powod_zam === 'KIEROWCA') ? 'Kierowcę' : 'Operatora'}</p>
                        }
                        <p><label>Typ płatności:</label> {(row.typ_plat == 'EXTRA') ? row.typ_plat + ' ' + acc.formatMoney(row.stawka) : row.typ_plat}
                        </p>
                    </div>
                </ReactTooltip>
            </div>)
        } else {
            // gdy kierowca nie był zmieniany

            return (<div>
                <div style={(row.zablokowane === 2 || row.czy_odw_obsada) ? {color: 'grey'} : {}}>{row.imie_naz} <span
                    style={{fontSize: "10px", background: "#dedede"}}
                    className={"label label-ebus-default"}>ID: {row.id_ki}</span>
                </div>
                {
                    Boolean(row.nr_tel_ebus) ?
                        <div title={'Telefon eBus do kierowcy'} style={{fontSize: '12px', marginTop: '3px'}}><span
                            className={'label label-ebus-default'} style={{fontSize: 'inherit'}}>
                            <i className={'fa fa-phone'}></i> {row.nr_tel_ebus}
                        </span>
                        </div>
                        :
                        ''
                }
            </div>)
        }
    }

    renderPojazd(cell, row) {
        return <span
            style={(row.zablokowane === 2 || row.czy_odw_obsada) ? {color: 'grey', fontSize: "12px"} : {fontSize: "12px"}}>{row.naz_po}</span>
    }

    renderMiejscaLabel() {
        return (
            <span style={{fontWeight: 'bold', fontSize: '11px'}}>
                <label style={{fontWeight: 'bold', fontSize: '14px'}}
                       title={'W przypadku kliknięcia na daną komórkę nastąpi przejście do szczegółowego widoku'}><i
                    className={'fa fa-info-circle'} style={{color: '#222', cursor: 'pointer', marginLeft: '3px'}}></i></label>
                <span className={'text-primary'}
                      style={{color: this.props.kolorRezerwacja}}>Rezer</span>,
                <span className={'text-success'}
                      style={{color: this.props.kolorSprzedany}}>Sprzed</span>,
                <span className={'text-warning'}
                      style={{color: this.props.kolorSkasowany}}>Skas</span>,
                <span className={'text-warning'}
                      style={{color: "#a83da7"}}>Odb.mies</span>,
                <span style={{color: "#888"}}>Wolne</span>,
                <span className={'text-danger'} style={{color: 'firebrick'}}>Brak</span>
            </span>
        )
    }

    renderMiejsca(cell, row) {

        let duplikaty = this.props.data.filter(k => k.id_ku === row.id_ku)

        let wyswietlProgressBar = true

        if (duplikaty.length > 1) { // jest więcej niż jeden kurs

            if (row.czy_bis) {
                wyswietlProgressBar = false
            }

            /*if (duplikaty[0].id_ob !== row.id_ob) {
                wyswietlProgressBar = false
            }*/
        }

        if (!wyswietlProgressBar) {
            return <div>
                <div style={{color: 'grey', fontSize: '12px', fontStyle: 'italic', textAlign: 'center', lineHeight: '30px'}}>
                    <span>kurs bisowy</span>
                    {(row.czy_cala_tr == 0) ? <span>, niepełna trasa</span> : ''}
                </div>

                <div style={{marginTop: "5px", fontSize:"10px",fontStyle: 'italic', color:"#333"}}>
                    <span>Skasował: {(row.ile_skas_kierowca !== null)?row.ile_skas_kierowca:"-"}</span>
                    <span style={{marginLeft:"5px"}}>Sprzedał: {(row.ile_sprz_kierowca !== null)?row.ile_sprz_kierowca:"-"}</span>
                </div>
            </div>
        }
        else {

            let wszystkie = 25
            if (row.il_miejsc_kurs > 0) {
                wszystkie = row.il_miejsc_kurs
            }

            let ile_odbic = 0;
            if(Boolean(row.ile_odb_mies_popr)){
                ile_odbic=row.ile_odb_mies_popr
            }

            // wartości procentowe
            let zarezerwowane = 0
            let sprzedane = 0
            let skasowane = 0
            let miesieczne = 0

            if (row.il_rez > 0) {
                zarezerwowane = (row.il_rez * 100) / wszystkie
            }
            if (row.il_sprz > 0) {
                sprzedane = (row.il_sprz * 100) / wszystkie
            }
            if (row.il_skas > 0) {
                skasowane = (row.il_skas * 100) / wszystkie
            }
            if(ile_odbic>0)
                miesieczne = (ile_odbic *100)/wszystkie

            return (
                <div style={{cursor: 'pointer'}}
                     title={'Kliknij aby wyświetlić informacje o sprzedaży'} onClick={() => this.onClickWyswietlInformacjeOSprzedazyIPromocjach(row)}>
                    <div data-tip='' data-for={'vobsada' + row.id_ob} data-place="bottom" className='tooltip_here'>
                        {
                            (wszystkie - row.il_rez - row.il_sprz - row.il_skas - ile_odbic < 0) ?
                                <ProgressBar style={{marginBottom: '2px'}}>
                                    <ProgressBar bsStyle="danger"
                                                 now={(Math.abs(wszystkie - row.il_rez - row.il_sprz - row.il_skas -ile_odbic) * (100 / wszystkie))} key={1}
                                                 style={{background: 'firebrick'}}/>
                                </ProgressBar>
                                :
                                <ProgressBar style={{marginBottom: '2px'}}>
                                    <ProgressBar bsStyle="primary"
                                                 style={{background: this.props.kolorRezerwacja}}
                                                 now={zarezerwowane} key={1}/>
                                    <ProgressBar bsStyle="success"
                                                 style={{background: this.props.kolorSprzedany}}
                                                 now={sprzedane} key={2}/>
                                    <ProgressBar bsStyle="warning"
                                                 style={{background: this.props.kolorSkasowany}}
                                                 now={skasowane} key={3}/>
                                    <ProgressBar bsStyle="warning"
                                                 style={{background: "#a83da7"}}
                                                 now={miesieczne} key={4}/>
                                </ProgressBar>
                        }
                        <div style={{fontSize: '16px'}}>
                        <span title={'Ilość miejsc zarezerowanych'} className={'text-primary'}
                              style={{fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorRezerwacja}}>
                           R: {row.il_rez}
                        </span>,
                            <span title={'Ilość miejsc sprzedanych'} className={'text-success'}
                                  style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorSprzedany}}>
                           S: {row.il_sprz}
                        </span>,
                            <span title={'Ilość skasowanych miejsc'}
                                  style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorSkasowany}}>
                           Sk: {row.il_skas}
                        </span>,
                            <span title={'Ilość odbić miesięcznych poprawnych / niepoprawnych'}
                                  style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: "#a83da7"}}>
                                M: {ile_odbic}{row.ile_odb_mies_niepopr?<span>/<span style={{color:'red'}}>{row.ile_odb_mies_niepopr}</span></span>:''}
                        </span>,
                            {
                                (wszystkie - row.il_rez - row.il_sprz - row.il_skas-ile_odbic < 0) ?
                                    <span title={'Ilość brakujących miejsc'}
                                          style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: 'firebrick'}}>
                           B: {(wszystkie - row.il_rez - row.il_sprz - row.il_skas-ile_odbic)}
                        </span>
                                    :
                                    <span title={'Ilość wolnych miejsc'}
                                          style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: '#888'}}>
                           W: {(row.il_miejsc_kurs > 0) ? wszystkie - row.il_rez - row.il_sprz - row.il_skas-ile_odbic : '?'}
                        </span>
                            }
                            {
                                Boolean(row.czy_promocja) ?
                                    <span className={'pull-right'} style={{color: 'dodgerblue', fontSize: '12px', marginTop: '3px'}}><i
                                        className={'fa fa-tags'}></i> promocja</span>
                                    :
                                    ''
                            }
                        </div>
                        {
                            (row.il_miejsc_kurs > 0) ?
                                (wszystkie - row.il_rez - row.il_sprz - row.il_skas-ile_odbic < 0) ?
                                    <div style={{color: 'firebrick', textAlign: 'center', marginTop: '3px', fontSize: '12px'}}>
                                        <i className={'fa fa-exclamation-circle'}></i> Brak wolnych miejsc - należy utworzyć kurs bisowy
                                    </div>
                                    :
                                    ''
                                :
                                ''
                        }
                        <div style={{marginTop: "5px", fontSize:"10px",fontStyle: 'italic', color:"#333"}}>
                            <span>Skasował: {(row.ile_skas_kierowca !== null)?row.ile_skas_kierowca:"-"}</span>
                            <span style={{marginLeft:"5px"}}>Sprzedał: {(row.ile_sprz_kierowca !== null)?row.ile_sprz_kierowca:"-"}</span>
                        </div>
                    </div>
                    <ReactTooltip id={'vobsada' + row.id_ob}>
                        <div>
                            <span>Ilość zarezerwowanych:</span><label style={{marginLeft: '3px'}}>{row.il_rez}</label>
                        </div>
                        <div>
                            <span>Ilość sprzedanych miejsc:</span><label style={{marginLeft: '3px'}}>{row.il_sprz}</label>
                        </div>
                        <div>
                            <span>Ilość skasowanych miejsc:</span><label style={{marginLeft: '3px'}}>{row.il_skas}</label>
                        </div>
                        <div>
                            <span>Ilość odbić miesięcznych poprawnych:</span><label style={{marginLeft: '3px'}}>{ile_odbic}</label>
                        </div>
                        <div>
                            <span>Ilość odbić miesięcznych niepoprawnych:</span><label style={{marginLeft: '3px'}}>{row.ile_odb_mies_niepopr? row.ile_odb_mies_niepopr:'-'}</label>
                        </div>

                        <div>
                            <span>Ilość wszystkich miejsc:</span><label
                            style={{marginLeft: '3px'}}>{(row.il_miejsc_kurs > 0) ? wszystkie : '?'}</label>
                        </div>
                        {
                            (wszystkie - row.il_rez - row.il_sprz - row.il_skas < 0) ?
                                <div>
                                    <span style={{fontWeight: 'bold'}}>Ilość brakujących miejsc:</span><label
                                    style={{marginLeft: '3px'}}>{(row.il_miejsc_kurs > 0) ? wszystkie - row.il_rez - row.il_sprz - row.il_skas-ile_odbic : '?'}</label>
                                </div>
                                :
                                <div>
                                    <span>Ilość wolnych miejsc:</span><label
                                    style={{marginLeft: '3px'}}>{(row.il_miejsc_kurs > 0) ? wszystkie - row.il_rez - row.il_sprz - row.il_skas-ile_odbic : '?'}</label>
                                </div>
                        }
                        {
                            Boolean(row.czy_promocja) ?
                                <div><label><i className={'fa fa-tags'}></i> Kurs objęty promocją</label></div>
                                :
                                ''
                        }
                    </ReactTooltip>
                </div>
            )
        }
    }


    renderStatus(cell, row) {
        if (row.czy_bis) {
            return (<div>
                <div style={{color: 'grey', fontSize: '12px', fontStyle: 'italic', textAlign: 'center', lineHeight: '30px'}}>kurs bisowy</div>
                {
                    Boolean(row.czy_odw_obsada) ?
                        <div style={{color: "chocolate", fontSize: "12px", textAlign: "center"}}><i className={"fa fa-times"}></i> bis odwołany</div>
                        : ""
                }
            </div>)
        } else {

            if (Boolean(row.start_kursu)) {
                return (
                    <div
                        style={{background: Boolean(row.czy_raport) ? "rgba(50,220,50,0.1)" : Boolean(row.koniec_kursu) ? "rgba(255,0,0,0.1)" : "rgba(255,120,0,0.1)"}}>

                        <div style={{textAlign: 'center'}}
                             title={'Kurs rozpoczął się dnia ' + row.start_kursu.substr(0, 10) + ' o godzinie ' + row.start_kursu.substr(11, 5)}>
                            <div>
                                    <span style={{fontWeight: 'bold', marginRight: '3px', fontSize: '16px'}}>
                            <i className={'fa fa-clock-o'}></i>
                        </span>
                                <span style={{color: 'grey', fontSize: '12px', fontStyle: 'italic', marginRight: '5px'}}>
                            Start {row.start_kursu.substr(0, 10)} o:
                            </span>
                                <span style={{fontWeight: 'bold', fontSize: '16px'}}>
                            {row.start_kursu.substr(11, 5)}
                        </span>
                            </div>
                        </div>
                        {
                            Boolean(row.koniec_kursu) ?
                                <div style={{textAlign: 'center'}}
                                     title={'Kurs zakończył się się dnia ' + row.koniec_kursu.substr(0, 10) + ' o godzinie ' + row.koniec_kursu.substr(11, 5)}>
                                    <div>
                                    <span style={{fontWeight: 'bold', marginRight: '3px', fontSize: '16px'}}>
                                    <i className={'fa fa-flag-checkered'}></i>
                                    </span>
                                        <span style={{color: 'grey', fontSize: '12px', fontStyle: 'italic', marginRight: '5px'}}>
                                    Koniec {row.koniec_kursu.substr(0, 10)} o:
                                    </span>
                                        <span style={{fontWeight: 'bold', fontSize: '16px'}}>
                                    {row.koniec_kursu.substr(11, 5)}
                                    </span>
                                    </div>
                                </div>
                                :
                                ''
                        }
                        {
                            Boolean(row.czy_raport) ?
                                <div style={{textAlign: 'center'}}>
                                    <div style={{color: "forestgreen", fontSize: "10px"}}>
                                        <i className={'fa fa-check-circle'}></i> Raport został wykonany
                                    </div>
                                </div>
                                :
                                <div style={{textAlign: 'center'}}>
                                    <div style={{color: Boolean(row.koniec_kursu) ? "red" : "rgb(215,120,0)", fontSize: "10px"}}>
                                        <i className={'fa fa-exclamation-triangle'}></i> Nie wykonano jeszcze raportu!
                                    </div>
                                </div>
                        }

                    </div>)
            }
            else if (cell === 1) {
                return (
                    <div title={'Kliknij aby zmienić status na dostępny'}>
                        <TopButtonAction block btnColor={'default'} onClick={() => {
                            this.props.handleZmienStatus(row, false)
                        }} text={'zablokowany'} iconType={'fa fa-times'} className={'btn-status-niedostepny'}/>
                    </div>
                )
            }
            else if (cell === 2) {
                return (
                    <div title={'Kurs odwołany - brak akcji'}>
                        <TopButtonAction block btnColor={'default'} onClick={() => {
                        }} text={'odwołany'} iconType={'fa fa-repeat'} className={'btn-status-odwolany'}
                                         btnDisabled={true}
                        />
                    </div>
                )
            }
            else return (
                    <div title={'Kliknij aby zmienić status na zablokowany'}>
                        <TopButtonAction block btnColor={'default'} onClick={() => {
                            this.props.handleZmienStatus(row, true)
                        }} text={'dostępny'} iconType={'fa fa-check'} className={'btn-status-dostepny'}/>
                    </div>
                )
        }
    }

    renderKurs(cell, row) {

        let czasObecny = moment().add(1, 'hour').toJSON().substr(0, 16).replace('T', ' ')
        let czasKursu = row.data + ' ' + DateAndTimeFormat.formatHHMM(row.godz_1p)


        let czyOpozniony = ObsadaListaContainer.czyKursOpozniony(row)
        let czyRozpoczetySpozniony = ObsadaListaContainer.czyKursRozpoczetySpozniony(row)

        if (Boolean(cell)) {

            let czyPokazacLokalizacje = ((row.data === new Date().toJSON().substr(0, 10)) && row.start_kursu && row.zablokowane !== 2)

            let duplikaty = this.props.data.filter(k => k.id_ku === cell)

            if (duplikaty.length > 1) { // jest więcej niż jeden kurs - są bisowe
                return (<div style={{textAlign: 'center'}}>
                    <span className={'label label-ebus-secondary'} title={'Ten kurs jest bisowy'}
                          style={(row.zablokowane === 2 || row.czy_odw_obsada) ? {background: 'grey'} : {}}
                    >{cell}</span>
                    <TopIf isTrue={czyOpozniony}>
                        <div style={{color: 'red', fontSize: '10px', marginTop: '5px'}}>
                            <i className={'fa fa-clock-o'} style={{fontSize: '12px'}}></i> Kurs jest opóźniony!
                        </div>
                    </TopIf>
                    <TopIf isTrue={czyRozpoczetySpozniony}>
                        <div style={{color: 'orangered', fontSize: '10px', marginTop: '5px'}}>
                            <i className={'fa fa-exclamation'} style={{fontSize: '12px'}}></i> Kurs rozpoczął się później!
                        </div>
                    </TopIf>
                    <TopIf isTrue={czyPokazacLokalizacje}>
                        <div>
                            <Link target={'_blank'} to={'/konfiguracja/rozklad-jazdy/lokalizacja'}
                                  title={'Kliknij aby wyszukać lokalizację busa na mapie'} onClick={() => this.onClickWyszukajLokalizacjeKursu(row)}
                                  style={{fontSize: '10px'}}
                            >
                                <i className={'fa fa-map-marker'}></i> Pokaż lokalizację
                            </Link>
                        </div>
                    </TopIf>
                </div>)
            }
            else {
                return (<div style={{textAlign: 'center'}}>
                    <span className={'label label-ebus-primary'}
                          style={row.zablokowane === 2 ? {background: 'grey'} : {}}>{cell}</span>

                    <TopIf isTrue={czyOpozniony}>
                        <div style={{color: 'red', fontSize: '10px', marginTop: '5px'}}>
                            <i className={'fa fa-clock-o'} style={{fontSize: '12px'}}></i> Kurs jest opóźniony!
                        </div>
                    </TopIf>

                    <TopIf isTrue={czyRozpoczetySpozniony}>
                        <div style={{color: 'orangered', fontSize: '10px', marginTop: '5px'}}>
                            <i className={'fa fa-exclamation'} style={{fontSize: '12px'}}></i> Kurs rozpoczął się później!
                        </div>
                    </TopIf>
                    <TopIf isTrue={czyPokazacLokalizacje}>
                        <div>
                            <Link target={'_blank'} to={'/konfiguracja/rozklad-jazdy/lokalizacja'}
                                  title={'Kliknij aby wyszukać lokalizację busa na mapie'} onClick={() => this.onClickWyszukajLokalizacjeKursu(row)}
                                  style={{fontSize: '10px'}}
                            >
                                <i className={'fa fa-map-marker'}></i> Pokaż lokalizację
                            </Link>
                        </div>
                    </TopIf>
                </div>)
            }

        }
    }

    formatStatusObsady(cell, row) {
        if (cell !== null) {
            if (cell > 0) {
                return <div>
                    <div data-tip='' data-for={'obsada_row_status_' + row.id_ob} data-place="right" className='tooltip_here'
                         style={{cursor: 'pointer'}}>
                        <div style={{textAlign: 'center', marginTop: '5px'}}><i className={'fa fa-check'} style={{color: 'forestgreen'}}></i></div>
                        <ReactTooltip id={'obsada_row_status_' + row.id_ob}>
                            <div>
                                {
                                    Boolean(row.obsada_wpisal) ?
                                        <p>
                                            Wpisał obsade: {row.obsada_wpisal}
                                        </p> : ""
                                }
                                {
                                    Boolean(row.obsada_zmienil) ?
                                        <p>
                                            Zmienił obsade: {row.obsada_zmienil}
                                        </p> : ""
                                }
                                {
                                    Boolean(row.kurs_wpisal) ?
                                        <p>
                                            Wpisał kurs: {row.kurs_wpisal}
                                        </p> : ""
                                }
                                {
                                    Boolean(row.kurs_zmienil) ?
                                        <p>
                                            Zmienił kurs: {row.kurs_zmienil}
                                        </p> : ""
                                }

                                {
                                    Boolean(row.bis_dodal_kto) ?
                                        <p>
                                            Wpisał bis: {row.bis_dodal_kto}
                                        </p>
                                        :
                                        ""
                                }
                                {
                                    (Boolean(!row.obsada_wpisal) && Boolean(!row.obsada_zmienil) && Boolean(!row.kurs_wpisal) && Boolean(!row.kurs_zmienil) && Boolean(!row.bis_dodal_kto)) ?
                                        <p>brak modyfikacji, wpis wygenerowany</p> : ""
                                }
                            </div>
                        </ReactTooltip>
                    </div>
                </div>
            } else {
                return (<div>
                    <div data-tip='' data-for={'obsada_row_status_' + row.id_ob} data-place="right" className='tooltip_here'
                         style={{cursor: 'pointer'}}>
                        <div style={{textAlign: 'center', marginTop: '5px'}}>
                            {
                                Boolean(cell === 0) ?    // brak kierowcy
                                    <div>
                                        <i className={'fa fa-user-times'} style={{color: 'firebrick'}}></i>
                                    </div>
                                    :
                                    Boolean(cell === -1) ?   // brak pojazdu, else brak obydwu
                                        <div>
                                            <i className={'fa fa-bus'} style={{color: 'firebrick'}}></i>
                                        </div>
                                        :
                                        <div>
                                            <i className={'fa fa-user-times'} style={{color: 'firebrick', marginRight: '3px'}}></i>
                                            <i className={'fa fa-bus'} style={{color: 'firebrick'}}></i>
                                        </div>
                            }
                        </div>
                    </div>
                    <ReactTooltip id={'obsada_row_status_' + row.id_ob}>
                        <div>

                            {
                                Boolean(cell === 0) ?    // brak kierowcy
                                    <div>
                                        Brak kierowcy
                                    </div>
                                    :
                                    Boolean(cell === -1) ?   // brak pojazdu, else brak obydwu
                                        <div>
                                            Brak pojazdu
                                        </div>
                                        :
                                        <div>
                                            Brak kierowcy oraz pojazdu
                                        </div>
                            }
                        </div>
                    </ReactTooltip>
                </div>)
            }

        }
    }


    expandComponent(row) {

        return <div style={{borderBottom: '3px solid #83c33a', paddingBottom: '5px'}}>
            <div className={'well well-sm'} style={{marginBottom: '5px'}}>
                {row.naz_pr_od} <i className={'fa fa-long-arrow-right'}></i> {row.naz_pr_do}

            </div>
        </div>

    }

    expandColumnComponent({isExpandableRow, isExpanded}) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ?
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-up'></i>)
                    :
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-down'></i>)
            )
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

    isExpandableRow(row) {
        return (row.czy_cala_tr === 0)
    }


    render() {

        let statusy = {
            "-2": 'brak kierowcy oraz pojazdu',
            "-1": 'brak pojazdu',
            "0": 'brak kierowcy',
            "1": 'prawidłowy'
        }

        let statusyzablokowane = {
            0: 'dostępny',
            1: 'zablokowany',
            2: 'odwołany'
        }

        const options = {
            sizePerPage: 30,  // Showing 15 for the size per page as default
            sizePerPageList: [10, 15, 30, 50, 100],
            noDataText: 'Brak pasujących rekordów',
            expandBy: 'column'
        };

        return (
            <div>
                <div>
                    <div className="bigger_table_for_1399">
                        <BootstrapTable data={this.props.data}
                                        options={options}
                                        pagination
                                        hover
                                        expandableRow={this.isExpandableRow}
                                        expandComponent={this.expandComponent}
                                        expandColumnOptions={{
                                            expandColumnVisible: true,
                                            expandColumnComponent: this.expandColumnComponent,
                                            columnWidth: 30,
                                        }}
                        >
                            <TableHeaderColumn dataField='id_ob' isKey hidden={true}>ID</TableHeaderColumn>
                            {/*<TableHeaderColumn dataField='trasa'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false} dataSort
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Trasa</TableHeaderColumn>*/}
                            <TableHeaderColumn dataField='status_obsady'
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={false} dataSort
                                /*filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}*/
                                               dataFormat={this.formatStatusObsady}
                                               filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                               formatExtraData={statusy}
                            >Status</TableHeaderColumn>
                            <TableHeaderColumn dataField='ekipa_trasa'
                                               thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                               filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                               dataFormat={this.renderEkipa}
                            >Trasa / Ekipa</TableHeaderColumn>
                            <TableHeaderColumn dataField='il_rez'
                                               thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} expandable={false}
                                               dataFormat={this.renderMiejsca}
                            >{this.renderMiejscaLabel()}</TableHeaderColumn>
                            <TableHeaderColumn dataField='id_ku'
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                               filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                               dataFormat={this.renderKurs}
                            >Kurs</TableHeaderColumn>
                            <TableHeaderColumn dataField='data'
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false} dataSort
                                               filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                               dataFormat={(cell, row) => {
                                                   return <span
                                                       style={(row.zablokowane === 2 || row.czy_odw_obsada) ? {color: 'grey'} : {}}>{cell}</span>
                                               }}
                            >Data</TableHeaderColumn>
                            <TableHeaderColumn dataField='godz_1p'
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={false} dataSort
                                               filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                               dataFormat={this.formatGodzina}
                            >G.</TableHeaderColumn>
                            <TableHeaderColumn dataField='imie_naz'
                                               thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} expandable={false}
                                               filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                               dataFormat={this.renderKierowca}
                            >Kierowca</TableHeaderColumn>
                            <TableHeaderColumn dataField='naz_po'
                                               thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                               filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                               dataFormat={this.renderPojazd}
                            >Pojazd</TableHeaderColumn>
                            <TableHeaderColumn dataField='zablokowane'
                                               thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false} dataSort
                                               filter={{type: 'SelectFilter', options: statusyzablokowane, selectText: 'Wybierz'}}
                                               formatExtraData={statusyzablokowane}
                                               dataFormat={this.renderStatus}
                            >Zablok. kurs (esprzedaż)?</TableHeaderColumn>
                            <TableHeaderColumn dataField='id_ob'
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                               dataFormat={this.renderButtonyAkcji}
                            >{TabUtilities.returnTrzyDowolneAkcjeHtml('Duplikuj', '#333', 'Edytuj', 'dodgerblue', 'Odwołaj kurs', 'firebrick')}</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
                {
                    this.state.pokazModal && Boolean(this.state.obsadaModal) ?
                        <div id={'EBUSModalContainerBG'}>
                            <div id={'modalContainer'} className={'modalFakturaDuzy'}>
                                <div>
                                    <div id={'modalTextContent'}>
                                        <div>
                                            <div className={'pull-right'}>
                                                <TopButtonAction onClick={() => {
                                                    this.setState({pokazModal: false, obsadaModal: null, promocjeDlaKursu: []})
                                                }}
                                                                 elementStyle={{color: 'firebrick'}}
                                                                 btnColor={'default'} text={'Zamknij'}
                                                                 iconType={'fa fa-times'}
                                                />

                                            </div>
                                        </div>
                                        <div style={{clear: 'both', height: '15px'}}></div>
                                        {
                                            this.state.setLoader ?
                                                <div id={'simple-small-loader'}>
                                                    <i className={'fa fa-spinner fa-spin'}></i>
                                                </div>
                                                :
                                                <ObsadaListaModal obsada={this.state.obsadaModal}
                                                                  promocjeDlaKursu={this.state.promocjeDlaKursu}
                                                                  kolorRezerwacja={this.props.kolorRezerwacja}
                                                                  kolorSprzedany={this.props.kolorSprzedany}
                                                                  kolorSkasowany={this.props.kolorSkasowany}

                                                />
                                        }

                                        <div style={{clear: 'both'}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        ''
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaLista/components/ObsadaListaTable.js